let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1t72e")).then(() => parcelRequire('71H9N'));